import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache
} from '@apollo/client';
import { createFragmentRegistry } from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';

import { storefrontGlobalFragments } from '@/shared/graphql/storefront/fragments';
import { ensureStorefrontEndpointUrl } from '@/shared/utils/storefront-endpoint';

export { ensureStorefrontEndpointUrl };

/**
 * Enriches context with a Shopify Public Access Token
 * @param accessToken Shopify Public Access Token
 * @returns ApolloLink
 */
const enrichLink = (accessToken: string) =>
  setContext((_, { headers }) => ({
    headers: {
      ...headers,
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': accessToken
    }
  }));

/**
 * Initialize ApolloClient for Shopify Storefront
 * @param url - Shopify url or complete Storefront GraphQL JSON url
 * @param accessToken Shopify Public Access Token
 * @returns ApolloClient
 */
export const initStorefrontApolloClient = (url: string, accessToken: string) =>
  new ApolloClient({
    link: ApolloLink.from([
      enrichLink(accessToken),
      createHttpLink({ uri: ensureStorefrontEndpointUrl(url) })
    ]),
    cache: new InMemoryCache({
      fragments: createFragmentRegistry(storefrontGlobalFragments)
    })
  });
